module.exports = __webpack_public_path__ + "img/main-mid-icon5.924dea01.png";